import React from "react";
import { TextBlockConfigurationRecord } from "models/view-models/block-configurations/text-block-configuration-record";
import { PageBlockContentProps } from "molecules/page-block-content/page-block-content";

interface TextBlockContentProps extends PageBlockContentProps {}

const CSS_CLASS_NAME = "c-text-block-content";

const TextBlockContent = ({ block, printable }: TextBlockContentProps) => {
    const configuration = new TextBlockConfigurationRecord(block.configuration);

    return (
        <div
            className={`${CSS_CLASS_NAME} ql-editor ${printable ? "-printable" : ""}`}
            dangerouslySetInnerHTML={{
                __html: configuration.getRenderableContent(),
            }}
            data-test-id="page--text-block--content"
        />
    );
};

export default TextBlockContent;
